export type ThemeMode = 'light' | 'dark' | 'auto';
export type ResolvedTheme = 'light' | 'dark';
export const THEME_STORAGE_KEY = 'hostvsl.theme';

export function validThemeMode(value: unknown): ThemeMode {
  return value === 'dark' || value === 'auto' ? value : 'light';
}

export function readThemeMode(): ThemeMode {
  try { return validThemeMode(localStorage.getItem(THEME_STORAGE_KEY)); }
  catch { return 'light'; }
}

export function resolveTheme(mode: ThemeMode): ResolvedTheme {
  if (mode !== 'auto') return mode;
  return typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(theme: ResolvedTheme) {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  document.body?.classList.toggle('dark', theme === 'dark');
  document.documentElement.style.colorScheme = theme;
}
